import { useMemo } from "react";
import { useTellescopeQuery } from "@tellescope/tanstack-query";
import type { ChatMessagePayload, ParsedChatMessage } from "../types";

export const useLoadConversation = (conversationId: string | null) => {
  const query = useTellescopeQuery({
    model: "ai_conversations",
    method: "getOne",
    request: conversationId ?? "",
    enabled: !!conversationId,
  });

  const parsedMessages = useMemo<ParsedChatMessage[]>(() => {
    if (!query.data?.messages) return [];

    return query.data.messages.map((msg: { role: string; text: string; timestamp?: Date }) => {
      let payload: ChatMessagePayload;
      try {
        payload = JSON.parse(msg.text);
      } catch {
        payload = { type: "text", content: msg.text };
      }
      return {
        role: msg.role as "user" | "assistant",
        timestamp: msg.timestamp,
        payload,
      };
    });
  }, [query.data?.messages]);

  return {
    messages: parsedMessages,
    isLoading: query.isLoading,
    error: query.error,
  };
};
